import { Column } from '../../../report/models/column.model';

export function getMaxLength(column: Column, columnsMaxLength: Map<string,number>, lengthCurrentRow: number): string {
  if (!columnsMaxLength.get(column.Alias)) {
    columnsMaxLength.set(column.Alias, lengthCurrentRow);
  }
  else {
    if (columnsMaxLength.get(column.Alias) < lengthCurrentRow) {
      columnsMaxLength.set(column.Alias, lengthCurrentRow);
    }
  }

  let columLength = columnsMaxLength.get(column.Alias) * 10 > 300 ? 300 : columnsMaxLength.get(column.Alias) * 10;
  return (columLength).toString() + 'px';
}
